import React from 'react';
import { Panel, IPanelProps } from 'core/decorators/Panel';
import { Query } from 'core/api/typedQuery';
import Tag from './entities/Tag';
import { BlockView } from 'common/views/block/BlockView.view';
import UserPreferencesConfig from './UserPrerencesConfig';
import Loading from 'common/fragments/Loading';
import { isEmpty } from 'core/util/ArrayUtils';
import { CheckBoxList, CheckBoxOption } from 'common/fragments/CheckBoxList';
import { ButtonView, ButtonVariant } from 'common/views/button/Button.view';
import TokenSession from 'core/util/session/TokenSession';
import ServiceRegistry from 'core/util/ServiceRegistry';
import UserTagAction from './entities/UserTagAction';
import labelProvider from './UserPreferences.labels';
import MenuTreeView, { IMenuNode, MenuTreeVariant } from 'common/views/menuTree/MenuTree.view';
import Label from 'core/components/label/Label';


interface ITagParam {
    tagSetName?:string;
    tagSetNames?:string[];
    includeUserSelection?:boolean;
}

export interface IUserPreferenceProps extends IPanelProps<UserPreferencesConfig>{
    tagSetName?:string;
    tagSetNames?:string[];
    includeUserSelection?:boolean;
    onSaved?:(entity: any) => void;
}

const { Labels } = labelProvider;
const TagQuery = Query.queryMany<Tag, ITagParam>(Tag);

@Panel({id:"userPreferences",configClass:UserPreferencesConfig, pageParams:true,labelProvider})
export class UserPreferencesPanel extends React.PureComponent<IUserPreferenceProps> {
    state = {preferences:[]};

    public render() {
        const { config } = this.props;
        const params = {includeUserSelection:true, tagSetNames: this.props.tagSetNames || config.tagSetNames || null};

        return (
            <React.Fragment>
                <TagQuery key="tagQuery" params={params}>
                {
                    ({data, loading}) => {
                        if (loading) {
                            return <Loading key="loading" />;
                        }
                        
                        if (isEmpty(data)) {
                            return (
                                <div></div>
                            );
                        }
                        
                        let options = [];
                        data.map((tag) => {
                            options.push(
                                this.mapToNode(tag)
                            );
                        });

                        return (
                            <React.Fragment>
                                {/* <CheckBoxList key="checkList" 
                                    values={options} 
                                    onChange={(values)=>this.handleChange(values)}
                                    showByCategory={true}
                                    >
                                    
                                </CheckBoxList> */}
                               <MenuTreeView viewKey="menu" onSelectItem={this.handleChange} variant={MenuTreeVariant.PILLS}
                                        onExpandedStateChange={this.onExpandedStateChange} items={options} />
                                <BlockView viewKey="user.preferences.submit">
                                    <ButtonView viewKey="preferences.submit" variant={ButtonVariant.PRIMARY} button={true} onClick={this.savePreferences}>
                                    <Labels.Submit/>
                                    </ButtonView>
                                </BlockView>
                            </React.Fragment>
                        );
                    }
                }
                </TagQuery>
            </React.Fragment>
        );
    }

    private handleChange = (values) => {
        this.setState({preferences:values});
    }
    private mapToNode = (tag: Tag): IMenuNode => {
        return {
            id: "tag-" + tag.id,
            label: <Label k={`Tag.${tag.id}.name`} v={tag.name} />,
            isSelectable: true
        };
    }

    private onExpandedStateChange = () => {

    }


    private savePreferences = () => {
       
        let tagIds=[];
        let userId = TokenSession.getUserId();
        let options = this.state.preferences;

        options.map(tag => {
            if(tag.checked) tagIds.push(tag.id);
        });
    
        const ut = {id:0,userId,tagIds,clearExisting:true};

        ServiceRegistry.getMutationService().create(ut, UserTagAction).then((result) => {
            console.log('preferences saved');
            if (this.props.onSaved) {
                this.props.onSaved(result);
            }
		});
    }
}


// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/UserPreferences.panel.tsx